module.exports = __webpack_public_path__ + "3ad1eacae7726944471384940ea80b0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/06_JET_PRI_02.png
// module id = 106
// module chunks = 0